function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-reading-aloud-91487");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-reading-aloud-91487",
  transform: "translate(0.390000, 0.378000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M235.21,89.602 C235.21,139.086 195.093,179.2 145.608,179.2 C96.123,179.2 56.006,139.087 56.006,89.602 C56.006,40.117 96.123,-1.42108547e-14 145.608,-1.42108547e-14 C195.093,-1.42108547e-14 235.21,40.117 235.21,89.602",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.84217094e-14,235.212 C2.84217094e-14,204.294 25.078,179.212 56.004,179.212 C86.922,179.212 112.004,204.294 112.004,235.212 L112.004,369.622 L246.404,369.610281 C271.146,369.610281 291.205,389.669281 291.205,414.411281 C291.205,439.153281 271.146,459.212281 246.404,459.212281 L0.004,459.223999 L0.004,347.223999 L2.84217094e-14,235.212 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.41,235.212 C302.41,266.138 277.336,291.212 246.41,291.212 C215.48,291.212 190.41,266.138 190.41,235.212 C190.41,204.282 215.48,179.212 246.41,179.212 C277.336,179.212 302.41,204.282 302.41,235.212",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.4,347.212 C134.4,316.294 159.478,291.212 190.4,291.212 C221.326,291.212 246.408,316.294 246.408,347.212 L134.4,347.212 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "375.21 291.222 364.007 313.632 414.409 347.222 347.21 347.222 291.21 459.222 403.21 459.222 459.21 347.222"
})));

var SvgStoryTelling = function SvgStoryTelling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "460px",
    height: "460px",
    viewBox: "0 0 460 460",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoryTelling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/StoryTelling.f4c315ee.svg";
export { ForwardRef as ReactComponent };